import { HTTP } from '@/utils/http';
import * as actions from '../types/actions';
import * as mutations from '../types/mutations';

export default {
  actions: {
    async [actions.DO_CREATE_EVENT_PACKAGE]({ commit }, payload) {
      const { id } = payload;
      const params = Object.assign({}, payload);
      delete params.id;
      const { data } = await HTTP.post(`/events/${id}/packages`, params);
      commit(mutations.SET_EVENT_PACKAGE, data.data.packages[0]);
      return data;
    },
    async [actions.DO_DELETE_EVENT_PACKAGE]({ commit }, payload) {
      const { id } = payload;
      const params = Object.assign({}, payload);
      delete params.id;
      const { data } = await HTTP.delete(`/event_packages/${id}`, params);
      commit(mutations.SET_EVENT_PACKAGE, {});
      return data;
    },
    async [actions.DO_UPDATE_EVENT_PACKAGE]({ commit }, payload) {
      const { id } = payload;
      const params = Object.assign({}, payload);
      delete params.id;
      const { data } = await HTTP.patch(`/event_packages/${id}`, params);
      commit(mutations.SET_EVENT_PACKAGE, data.data.packages[0]);
      return data;
    },
  },
  getters: {},
  mutations: {
    [mutations.SET_EVENT_PACKAGE](state, eventPackage) {
      state.eventPackage = eventPackage;
    },
  },
  state: {
    eventPackage: {},
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/event_package.js